export const WORKOUTS = [
  {
    title: 'Pull-ups',
    body: 'wide / narrow / static',
  },
  {
    title: 'Push-ups',
    body: 'incline / decline / wide / explosive',
  },
  {
    title: 'Legs',
    body: 'lunges / jump squats / weighted squats',
  },
  {
    title: 'Chin-ups',
    body: 'wide / narrow / head-banger',
  },
  {
    title: 'Abs',
    body: 'leg raises / static holds / no situps!',
  },
];

export const WORKOUT_PLACEHOLDER = {
  title: '--',
  body: '--',
};
